/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
/** Address prefix used to find on-market listings. */
export type MarketplaceAddressSearchInput = {
  /** Street or address prefix to match; must contain 2 to 200 characters. */
  query: Types.Scalars['NonEmptyString']['input'];
};

/** Text, optional location, and zone types for finding marketplace zones. */
export type MarketplaceZoneSearchInput = {
  /** Optional latitude used to rank nearby matches, in decimal degrees. */
  latitude?: Types.Scalars['Latitude']['input'] | null | undefined;
  /** Maximum zone suggestions to return, up to 100; defaults to 20. */
  limit?: Types.Scalars['SafeInt']['input'] | null | undefined;
  /** Optional longitude used to rank nearby matches, in decimal degrees. */
  longitude?: Types.Scalars['Longitude']['input'] | null | undefined;
  /** Text to match against marketplace zone names. */
  query: Types.Scalars['NonEmptyString']['input'];
  /** Zone types to include; an omitted value includes all supported types. */
  types?: Array<MarketplaceZoneType> | null | undefined;
};

/** Geographic level of a marketplace search zone. */
export type MarketplaceZoneType =
  /** A city or town. */
  | 'CITY'
  /** A county or county-equivalent region. */
  | 'COUNTY'
  /** A broad neighborhood grouping. */
  | 'MACRO_NEIGHBORHOOD'
  /** A neighborhood-level area. */
  | 'NEIGHBORHOOD'
  /** A defined residential service boundary. */
  | 'RESIDENTIAL_BOUNDARY'
  /** A US state or equivalent state-level region. */
  | 'STATE'
  /** A smaller area within a neighborhood. */
  | 'SUBNEIGHBORHOOD'
  /** The geographic level could not be determined. */
  | 'UNKNOWN'
  /** A postal ZIP code area. */
  | 'ZIP_CODE';

export type MarketplacePropertySuggestionFragment = { addressId: Types.Scalars['UUID']['output'], fullAddress: Types.Scalars['String']['output'] | null, listPriceCents: Types.Scalars['SafeInt']['output'] | null };

export type MarketplaceZoneSuggestionFragment = { displayTextPrimary: Types.Scalars['String']['output'] | null, displayTextSecondary: Types.Scalars['String']['output'] | null, zone: { boundingBox: Types.Scalars['String']['output'] | null, id: Types.Scalars['ID']['output'], name: Types.Scalars['NonEmptyString']['output'], population: Types.Scalars['SafeInt']['output'] | null, stateAbbr: Types.Scalars['String']['output'] | null, type: Types.MarketplaceZoneType, center: { latitude: Types.Scalars['Latitude']['output'], longitude: Types.Scalars['Longitude']['output'] } | null } };

export type MarketplaceLocationSuggestionsQueryVariables = Exact<{
  propertyInput: Types.MarketplaceAddressSearchInput;
  zoneInput: Types.MarketplaceZoneSearchInput;
}>;


export type MarketplaceLocationSuggestionsQuery = { marketplace: { addressSearch: Array<{ addressId: Types.Scalars['UUID']['output'], fullAddress: Types.Scalars['String']['output'] | null, listPriceCents: Types.Scalars['SafeInt']['output'] | null }> | null, searchZones: Array<{ displayTextPrimary: Types.Scalars['String']['output'] | null, displayTextSecondary: Types.Scalars['String']['output'] | null, zone: { boundingBox: Types.Scalars['String']['output'] | null, id: Types.Scalars['ID']['output'], name: Types.Scalars['NonEmptyString']['output'], population: Types.Scalars['SafeInt']['output'] | null, stateAbbr: Types.Scalars['String']['output'] | null, type: Types.MarketplaceZoneType, center: { latitude: Types.Scalars['Latitude']['output'], longitude: Types.Scalars['Longitude']['output'] } | null } }> | null } };

export type MarketplaceLocationZonesQueryVariables = Exact<{
  zoneInput: Types.MarketplaceZoneSearchInput;
}>;


export type MarketplaceLocationZonesQuery = { marketplace: { searchZones: Array<{ displayTextPrimary: Types.Scalars['String']['output'] | null, displayTextSecondary: Types.Scalars['String']['output'] | null, zone: { boundingBox: Types.Scalars['String']['output'] | null, id: Types.Scalars['ID']['output'], name: Types.Scalars['NonEmptyString']['output'], population: Types.Scalars['SafeInt']['output'] | null, stateAbbr: Types.Scalars['String']['output'] | null, type: Types.MarketplaceZoneType, center: { latitude: Types.Scalars['Latitude']['output'], longitude: Types.Scalars['Longitude']['output'] } | null } }> | null } };

export type MarketplaceLocationAddressesQueryVariables = Exact<{
  propertyInput: Types.MarketplaceAddressSearchInput;
}>;


export type MarketplaceLocationAddressesQuery = { marketplace: { addressSearch: Array<{ addressId: Types.Scalars['UUID']['output'], fullAddress: Types.Scalars['String']['output'] | null, listPriceCents: Types.Scalars['SafeInt']['output'] | null }> | null } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const MarketplacePropertySuggestionFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment MarketplacePropertySuggestion on MarketplaceListing {
  addressId
  fullAddress
  listPriceCents
}
    `, {"fragmentName":"MarketplacePropertySuggestion"}) as unknown as TypedDocumentString<MarketplacePropertySuggestionFragment, unknown>;
export const MarketplaceZoneSuggestionFragmentDoc = /*#__PURE__*/ new TypedDocumentString(`
    fragment MarketplaceZoneSuggestion on MarketplaceZoneSearchResult {
  displayTextPrimary
  displayTextSecondary
  zone {
    boundingBox
    center {
      latitude
      longitude
    }
    id
    name
    population
    stateAbbr
    type
  }
}
    `, {"fragmentName":"MarketplaceZoneSuggestion"}) as unknown as TypedDocumentString<MarketplaceZoneSuggestionFragment, unknown>;
export const MarketplaceLocationSuggestionsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query MarketplaceLocationSuggestions($propertyInput: MarketplaceAddressSearchInput!, $zoneInput: MarketplaceZoneSearchInput!) {
  marketplace {
    addressSearch(input: $propertyInput) {
      ...MarketplacePropertySuggestion
    }
    searchZones(input: $zoneInput) {
      ...MarketplaceZoneSuggestion
    }
  }
}
    fragment MarketplacePropertySuggestion on MarketplaceListing {
  addressId
  fullAddress
  listPriceCents
}
fragment MarketplaceZoneSuggestion on MarketplaceZoneSearchResult {
  displayTextPrimary
  displayTextSecondary
  zone {
    boundingBox
    center {
      latitude
      longitude
    }
    id
    name
    population
    stateAbbr
    type
  }
}`) as unknown as TypedDocumentString<MarketplaceLocationSuggestionsQuery, MarketplaceLocationSuggestionsQueryVariables>;
export const MarketplaceLocationZonesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query MarketplaceLocationZones($zoneInput: MarketplaceZoneSearchInput!) {
  marketplace {
    searchZones(input: $zoneInput) {
      ...MarketplaceZoneSuggestion
    }
  }
}
    fragment MarketplaceZoneSuggestion on MarketplaceZoneSearchResult {
  displayTextPrimary
  displayTextSecondary
  zone {
    boundingBox
    center {
      latitude
      longitude
    }
    id
    name
    population
    stateAbbr
    type
  }
}`) as unknown as TypedDocumentString<MarketplaceLocationZonesQuery, MarketplaceLocationZonesQueryVariables>;
export const MarketplaceLocationAddressesDocument = /*#__PURE__*/ new TypedDocumentString(`
    query MarketplaceLocationAddresses($propertyInput: MarketplaceAddressSearchInput!) {
  marketplace {
    addressSearch(input: $propertyInput) {
      ...MarketplacePropertySuggestion
    }
  }
}
    fragment MarketplacePropertySuggestion on MarketplaceListing {
  addressId
  fullAddress
  listPriceCents
}`) as unknown as TypedDocumentString<MarketplaceLocationAddressesQuery, MarketplaceLocationAddressesQueryVariables>;